export enum WhatsappActionType {
    ABNORMAL_RESULT = 'ABNORMAL_RESULT',
    BOOKING_APPOINTMENT ='BOOKING_APPOINTMENT',
    CANCEL_ADMISSION = 'CANCEL_ADMISSION',
    CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT',
    CLOSE_ER_VISITS = 'CLOSE_ER_VISITS',
    CLOSE_OUTPATIENT_VISIT = 'CLOSE_OUTPATIENT_VISIT',
    DISCHARGE_ADMISSION = 'DISCHARGE_ADMISSION',
    NEW_ADMISSION = 'NEW_ADMISSION',
    RELEASE_RESULT = 'RELEASE_RESULT',
    REMINDER_APPOINTMENT = 'REMINDER_APPOINTMENT',
    SEND_PANIC_RELEASED_RESULT = 'SEND_PANIC_RELEASED_RESULT',
    SEND_SURVEY = 'SEND_SURVEY'
}